import * as React from 'react';
import styled from '../theme';
import Logo from '../components/LogoComponent';

interface ITCProps {
    logo?: any;
    content: any;
    returnToRegistrationPage(): any;
}

class PolicyPage extends React.Component<ITCProps> {
    constructor(props: any) {
        super(props);
    }

    public render() {
        return (
            <MainWrapper>
                <Logo logo={this.props.logo} />
                <Title>{this.props.content.title}</Title>
                <Content>
                    {this.props.content.sections.map((section: any, index: number) => {
                        return (
                            <Section key={index}>
                                {section.heading ? <h2>{section.heading}</h2> : null}
                                <p dangerouslySetInnerHTML={{ __html: section.body }} />
                            </Section>
                        )
                    })}
                </Content>
                <Button onClick={this.props.returnToRegistrationPage}>{this.props.content.buttonLabel}</Button>
            </MainWrapper>
        )
    }
}

export default PolicyPage

const MainWrapper = styled.div`
    width: 100%;
    height: auto;
    min-height: 100%;
    position: absolute;
    top:0;
    left:0;
    display: flex;
    flex-direction: column;
    background: -webkit-linear-gradient(${(props: any) => props.theme.colors.backgroundDark2}, ${(props: any) => props.theme.colors.backgroundDark3});
    background: linear-gradient(${(props: any) => props.theme.colors.backgroundDark2}, ${(props: any) => props.theme.colors.backgroundDark3});
`

const Content = styled.div`
    width: 85%;
    margin-left: 7.5%;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 100%;
    flex: 1 0 auto;

    h2 {
        color: ${(props: any) => props.theme.colors.bodyLight};
        font-weight: 600;
        text-align: center;
    }

    p, a {
        color: ${(props: any) => props.theme.colors.bodyLight};
        font-size: 1em;
    }

    @media (max-width: 550px) {
        width: 100%;
        margin-left: 0;
        padding: 0 40px;
        box-sizing: border-box;
    }
`
const Section = styled.div`
    margin-bottom: 50px;
`
const Title = styled.h1`
    color: ${(props: any) => props.theme.colors.backgroundHighlight};
    text-align: center;
    font-weight: 400;
    font-size: 2em;
    width: 85%;
    text-transform: uppercase;
    margin: 50px 7.5% 30px 7.5%;

    @media (max-width: 550px) {
        margin: 50px 7.5% 20px 7.5%;
    }
`
const Button = styled.div`
    flex-shrink: 0;
    width: 85%;
    height: 60px;
    background:${(props: any) => props.theme.colors.backgroundHighlight};
    color: ${(props: any) => props.theme.colors.bodyHighlight};
    border: none;
    border-radius: 5px;
    font-weight: 800;
    font-size: 1.2em;
    text-align: center;
    line-height: 60px;
    margin: 0 0 6% 50%;
    transform: translateX(-50%);
`




// WEBPACK FOOTER //
// ./src/pages/PolicyPage.tsx